import { Flow } from "../types/IFlow";
import { NoConfirmationNoBookFlowLegacyNames } from "../types/FlowNames";
import {
  NoConfirmationDefaultNavigatorConfiguration,
  NoConfirmationPreQualifiedPatientNavigatorConfiguration
} from "./NavigatorConfigurations";
import {
  noConfirmationCenterSelectableBookingStepConfigurations,
  screeningStepConfigurations
} from "./StepConfigurations";

const noConfirmationNoBookFlowName = "NoConfirmationNoBookFlow";

/** The flow that a no-book guest should experience when booking without a confirmation step. */
class NoConfirmationNoBookFlow extends Flow {
  static readonly flowName = noConfirmationNoBookFlowName;
  readonly name = noConfirmationNoBookFlowName;
  readonly steps = { ...screeningStepConfigurations, ...noConfirmationCenterSelectableBookingStepConfigurations };
  readonly navigatorItems = NoConfirmationDefaultNavigatorConfiguration;
  isDisqualificationPossible() {
    return true;
  }

  override matchesFlowName(name: string): boolean {
    return name === this.name || NoConfirmationNoBookFlowLegacyNames.includes(name);
  }
}

/** The flow that a pre-qualified no-book guest should experience when booking without a confirmation step. */
export class PreQualifiedNoConfirmationNoBookFlow extends Flow {
  readonly name = noConfirmationNoBookFlowName;
  readonly steps = { ...noConfirmationCenterSelectableBookingStepConfigurations };
  readonly navigatorItems = NoConfirmationPreQualifiedPatientNavigatorConfiguration;
  isDisqualificationPossible() {
    return false;
  }

  override matchesFlowName(name: string): boolean {
    return name === this.name || NoConfirmationNoBookFlowLegacyNames.includes(name);
  }
}

export default NoConfirmationNoBookFlow;
